<soft-radio-group class="flex flex-col mt-4" #radio="softRadioGroup">
  <soft-radio-option [value]="undefined">
    <span class="soft-label right">
      {{ '#TICKETS.DIALOGS.EXPORT_TICKET.ALL' | translate }}
    </span>
  </soft-radio-option>
  @if (ticket()) {
    <soft-radio-option [value]="ticket().id">
      <span class="soft-label right">
        {{ '#TICKETS.DIALOGS.EXPORT_TICKET.TICKET' | translate | interpolate: ticket() }}
      </span>
    </soft-radio-option>
  }
</soft-radio-group>
<div class="flex flex-row justify-end mt-2">
  <button
    class="soft-button primary rounded hover:cursor-pointer"
    [disabled]="isDownloading$ | async"
    (click)="onDownload(radio.value()())"
  >
    @if (isDownloading$ | async) {
      <i class="fa-regular fa-spinner fa-spin"></i>
    }
    {{ '#TICKETS.DIALOGS.EXPORT_TICKET.SUBMIT' | translate }}
  </button>
</div>
